import { NonNullableStringParameter, useQueryParameter } from '@pba/react-router';
import { useEffect } from 'react';
import { apiClient } from 'common/services';

export const useApiClientConfigurationEffect = () => {
  const platform = useQueryParameter('platform', NonNullableStringParameter);
  const whiteLabel = useQueryParameter('config', NonNullableStringParameter);
  const version = useQueryParameter('version', NonNullableStringParameter);
  const token = useQueryParameter('token', NonNullableStringParameter);

  useEffect(() => {
    // TODO: ApiClient for mobile API endpoints needs to be separated so we can set custom Headers
    // NOTE: Remove default interceptors, otherwise it is not possible to override already defined request headers by Axios Interceptors
    apiClient.interceptors.request.clear();

    apiClient.defaults.headers.common['x-app-platform'] = platform ?? 'fe-rte';

    if (whiteLabel) {
      apiClient.defaults.headers.common['x-app-name'] = whiteLabel;
    }

    if (version) {
      apiClient.defaults.headers.common['x-app-version'] = version;
    }

    if (token) {
      apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
  }, [platform, token, version, whiteLabel]);
};
